/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Oci_NumberInputs */

const en_audit_oci_number = /** @type {(inputs: Audit_Oci_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI Number`)
};

const es_audit_oci_number = /** @type {(inputs: Audit_Oci_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero OCI`)
};

/**
* | output |
* | --- |
* | "OCI Number" |
*
* @param {Audit_Oci_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_oci_number = /** @type {((inputs?: Audit_Oci_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Oci_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_oci_number(inputs)
	return es_audit_oci_number(inputs)
});